import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FrameIsolation extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    renderCallback: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.node = null;
  }

  componentDidMount() {
    if (this.node) {
      this.props.renderCallback(this.node);
    }
  }

  render() {
    return <div ref={n => { this.node = n; }}>{this.props.children}</div>;
  }
}

export default FrameIsolation;

